import { useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'
import lockAbi from 'config/abi/candyLock.json'
import { Rarity } from 'config/constants/types'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { getCandyLockAddress } from 'utils/addressHelpers'
import { BIG_ZERO } from 'utils/bigNumber'
import { publicClient } from 'utils/wagmi'
import { LockDuration } from '../types'

// Retrieve Lock configuration
const useLockConfig = () => {
  const { account, chainId } = useActiveWeb3React()
  const [aprRates, setAprRates] = useState({})
  const [boostRates, setBoostRates] = useState({})
  const [minToken, setMinToken] = useState(BIG_ZERO)
  const [maxNft, setMaxNft] = useState(0)
  const [blacklisted, setBlacklisted] = useState(false)

  const candyLockAddress = getCandyLockAddress(chainId)

  useEffect(() => {
    const fetchConfiguration = async () => {
      const client = publicClient({ chainId })
      const contractCalls = Object.keys(LockDuration).slice(0, 4).map((duration) => ({
        abi: lockAbi,
        address: candyLockAddress,
        functionName: 'aprPerDuration',
        args: [duration],
      })).concat(
        Object.keys(Rarity).slice(0, 5).map((rarity) => ({
          abi: lockAbi,
          address: candyLockAddress,
          functionName: 'boostPerRarity',
          args: [rarity],
        })), [
          {
            abi: lockAbi,
            address: candyLockAddress,
            functionName: 'minTokenPerLock',
            args: []
          },
          {
            abi: lockAbi,
            address: candyLockAddress,
            functionName: 'maxNftPerLock',
            args: []
          }
        ]
      )

      // @ts-ignore
      const result = await client.multicall({ contracts: contractCalls, allowFailure: false })

      setAprRates(result.slice(0, 4).reduce((acc, elem, index) => {
        // eslint-disable-next-line
        // @ts-ignore
        const acc_ = { ...acc, [Object.values(LockDuration)[index]]: Number(elem) }
        return acc_
      }, {}))
      setBoostRates(result.slice(4, 9).reduce((acc, elem, index) => {
        // eslint-disable-next-line
        // @ts-ignore
        const acc_ = { ...acc, [Object.keys(Rarity)[index]]: Number(elem) }
        return acc_
      }, {}))
      setMinToken(new BigNumber(result[9].toString()))
      setMaxNft(Number(result[10]))
    }

    fetchConfiguration()
  }, [candyLockAddress, chainId])

  useEffect(() => {
    const fetchBlacklisted = async () => {
      const client = publicClient({ chainId })
      const result = await client.readContract({ 
        abi: lockAbi, 
        address: candyLockAddress,
        functionName: 'accountBlocked',
        args: [account]
      })
      setBlacklisted(result as boolean)
    }

    if (account) fetchBlacklisted()
  }, [candyLockAddress, chainId, account])

  return { aprRates, blacklisted, boostRates, maxNft, minToken }
}

export default useLockConfig
